"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.persistor = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _reduxPersist = require("redux-persist");
var _middleware = require("./middleware");
var _entities = require("./entities");
var _constants = require("../utils/constants");
const store = exports.store = (0, _toolkit.configureStore)({
  middleware: getDefaultMiddleware => {
    const defaultMiddleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [_reduxPersist.FLUSH, _reduxPersist.REHYDRATE, _reduxPersist.PAUSE, _reduxPersist.PERSIST, _reduxPersist.PURGE, _reduxPersist.REGISTER]
      }
    });
    const middleware = [...defaultMiddleware];
    if (process.env.NODE_ENV === _constants.NODE_ENV.development && process.env.NODE_ENV !== _constants.NODE_ENV.test) {
      middleware.push(_middleware.logger);
    }
    return middleware;
  },
  reducer: _entities.rootReducer
});
const persistor = exports.persistor = (0, _reduxPersist.persistStore)(store);